module.exports = __webpack_public_path__ + "static/media/selfServePremiumDot.63ea39d3.svg";